const formatMoney = (amount, displayCurrency = true) => {
	return `${amount.toFixed(2).replace(".", ",")}${
		displayCurrency ? " EUR" : ""
	}`;
};

export default formatMoney;
